import { render, staticRenderFns } from "./externalExchangeDeposit.vue?vue&type=template&id=64008907&scoped=true"
import script from "./externalExchangeDeposit.vue?vue&type=script&lang=js"
export * from "./externalExchangeDeposit.vue?vue&type=script&lang=js"
import style0 from "./externalExchangeDeposit.vue?vue&type=style&index=0&id=64008907&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64008907",
  null
  
)

export default component.exports